import React from 'react';
import { injectIntl } from 'react-intl';

import IntlDate from 'components/layout/IntlDate';

class SepaAgreementDetails extends React.Component {
  render() {
    const {
      intl: { messages },
      owner,
      target,
      sepaAgreement,
    } = this.props;

    return (
      <div class="padding-20">
        <h3>{messages.sepaAgreement.sepa_direct_debit_mandate}</h3>
        <dl>
          <dt>{messages.doc_issue_date}</dt>
          <dd>
            <IntlDate date={sepaAgreement.cdate} />
          </dd>
          <dt>{messages.sepaAgreement.mandate_reference}</dt>
          <dd>{sepaAgreement.agreement_id}</dd>
        </dl>

        <h4>{messages.sepaAgreement.payee}</h4>
        <dl>
          <dt>{messages.sepaAgreement.creditor}</dt>
          <dd>{owner.company}</dd>

          <dt class="m-t-5">{messages.creditor_id}</dt>
          <dd>{owner.creditor_id}</dd>
        </dl>

        <h4>{messages.sepaAgreement.payer}</h4>
        <dl>
          <dt>{messages.account_holder}</dt>
          <dd>{target.profile.company}</dd>

          <dt class="m-t-5">{messages.street + ' / ' + messages.house_number}</dt>
          <dd>
            {target.profile.street}
            {target.profile.house_number ? ' ' + target.profile.house_number : null}
            {target.profile.apartment_number ? ' ' + target.profile.apartment_number : null}
          </dd>

          <dt class="m-t-5">{messages.zip_code}</dt>
          <dd>{target.profile.zip_code}</dd>

          <dt class="m-t-5">{messages.city}</dt>
          <dd>{target.profile.city}</dd>

          <dt class="m-t-5">{messages.country}</dt>
          <dd>{target.profile.country_name}</dd>

          <dt class="m-t-5">
            {messages.iban} ({messages.account_number})
          </dt>
          <dd>{target.financial.bank_data.iban}</dd>

          <dt class="m-t-5">{messages.swift_bic}</dt>
          <dd>{target.financial.bank_data.swift_bic}</dd>
        </dl>
      </div>
    );
  }
}

export default injectIntl(SepaAgreementDetails);
